.wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.scrollBox {
  --vapor-scroll-container-gutter-size: 12px;

  -ms-overflow-style: -ms-autohiding-scrollbar;
  -webkit-overflow-scrolling: touch;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  overscroll-behavior: contain;
  z-index: 1;

  @supports (scrollbar-width: auto) {
    scrollbar-gutter: stable;
    scrollbar-color: var(--colors-border-tertiary-stark) transparent;
    scrollbar-width: auto;
  }
}

@supports selector(::-webkit-scrollbar) and (not (scrollbar-width: auto)) {
  .scrollBox:where([data-custom-scrollbars]) {
    --scrollbar-gap: 3px;
    --scrollbar-radii: 8px;
    --scrollbar-size: var(--vapor-scroll-container-gutter-size);
    --scrollbar-thumb: var(--colors-border-tertiary-stark);
    --scrollbar-track: transparent;

    &::-webkit-scrollbar {
      height: var(--scrollbar-size);
      width: var(--scrollbar-size);
    }

    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }

    &::-webkit-scrollbar-track {
      background-color: var(--scrollbar-track);
      border: var(--scrollbar-gap) solid var(--scrollbar-track);
    }

    &::-webkit-scrollbar-thumb {
      background-clip: padding-box;
      background-color: var(--scrollbar-thumb);
      border: var(--scrollbar-gap) solid transparent;
      border-radius: var(--scrollbar-radii);
      min-height: 40px;
      transition: visibility 200ms ease;
    }
  }
}

.shadow {
  --vapor-scroll-shadow-offset: 0px;
  --vapor-scroll-shadow-border-color: var(--colors-border-primary);

  background-position: top;
  background-repeat: no-repeat;
  background-size: 100%;
  height: var(--spaces-24);
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  z-index: 1;

  &:where([data-placement='top']) {
    bottom: unset;
    top: var(--vapor-scroll-shadow-offset);
  }

  &:where([data-placement='bottom']) {
    bottom: var(--vapor-scroll-shadow-offset);
    top: unset;
  }

  &:where([data-enable-shadow]) {
    background-image: var(--colors-background-scroll-top);
  }

  &:where([data-enable-shadow][data-placement='bottom']:not([data-shadow-size='small'])) {
    background-image: var(--colors-background-scroll-bottom);
  }

  &:where([data-enable-border][data-placement='top']) {
    border-top: 1px solid var(--vapor-scroll-shadow-border-color);
  }

  &:where([data-enable-border][data-placement='bottom']) {
    border-bottom: 1px solid var(--vapor-scroll-shadow-border-color);
  }
}
